import { NotificationSnackbarComponent, } from '@common/snackbar';
import { FirebaseMessagingService } from '@services/firebase-messaging.service';
import {Component, ViewChild, ChangeDetectorRef, ElementRef} from '@angular/core';
import { HttpClient } from '@services/http-client';
import { NavigationService } from '@services/navigation-service';
import { UserAvatarService } from '@services/user-avatar-service';
import { AuthenticationService } from '@services/auth-service';
import { ActividadService } from '@services/actividad-service';
import { NegociosService } from '@services/negocios-service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription }   from 'rxjs/Subscription';
import * as moment from 'moment';
import { MdSnackBar, MdDialog, MdIconRegistry} from '@angular/material';
import { environment } from '../environments/environment';
import {
  MonedaService,
  PosicionService,
  ProductoService,
  EntregaService,
  CategoriaService,
  PermisosService,
  PERM_ACCIONES_ID,
  ColaboradoresService,
  RemitosService,
  ActivityService
} from './services';
import { CosechaService } from '@services/cosecha-service';
import { SignalrService } from './signalr/signalR.service';
import { PATH_CUENTAS, PATH_ABM, } from './navigation/navigation.module';
import { PreciosService } from '@services/precios-service';
import { AgrisService } from '@services/agris-service';
import { FinancieraService } from '@services/financiera-service';
import { SideMenuScrollerComponent} from './components';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  @ViewChild('sidenav') sideNav:any;
  private toggleNav:any;
  private username: string;
  private avatarUrl = `${environment.IMAGES_URL}/images/${localStorage.getItem('userId')}.png`;
  //private avatarUrl = `${environment.IMAGES_URL}${localStorage.getItem('userId')}.png`;
  avatarSubscription: Subscription;

  public preciosBubble: boolean = false;
  public pizarraBubble: boolean = false;
  public financieraBubble: boolean = false;
  public sideNavButtonBubble: boolean = false;
  public comunicadosBubble: boolean = false;

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  jdeAllowed = false;

  public pubEnvironment = environment;

  @ViewChild('navBarContainer') navContainer!: ElementRef;
  @ViewChild(SideMenuScrollerComponent) scrollBar!: SideMenuScrollerComponent;
  private virtualScroll = false;
  private scrollTimer: number = 0;

  constructor(
    public navigationService: NavigationService,
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private actividadService: ActividadService,
    private avatarService: UserAvatarService,
    private negociosService: NegociosService,
    private posicionService: PosicionService,
    private entregaService: EntregaService,
    private productoService: ProductoService,
    private cosechaService: CosechaService,
    private monedaService: MonedaService,
    private router: Router,
    private firebaseService: FirebaseMessagingService,
    private signalRService: SignalrService,
    private preciosService: PreciosService,
    public snackBar: MdSnackBar,
    private zonaService: CategoriaService,
    private permisosService: PermisosService,
    private agrisService: AgrisService,
    private financieraService: FinancieraService,
    private colaboradoresService: ColaboradoresService,
    private dialog: MdDialog,
    private matIconRegistry: MdIconRegistry,
    private domSanitizer: DomSanitizer,
    private remitosService: RemitosService,
    private activityService: ActivityService
  ) {

    // registramos los iconos SVG para usarlos con el componente <md-icon>
    this.registrarIconosSVG();

    navigationService.toggleNav$.subscribe( value => {
        this.toggleNav();
    });

    this.username = localStorage.getItem('username');

    this.signalRService.initializeService();

    if (this.username) {
      // Si estoy logueado y signalr está inicializado me conecto al mismo
      this.signalRService.isInitialized.subscribe(b => {
        if (b) {
          this.signalRService.startConnection();
        }
      });

      // Si estoy logueado, enviar evento login a tag manager
      this.registerAnalyticsUser();

    }

    this.authService.isLoggedIn().subscribe( isLoggedIn => {
      if (isLoggedIn) {
        this.username = localStorage.getItem('username');
        if (this.username) {
          this.loadNegocioOptions();
          this.actividadService.checkNewActivities();
          this.preciosService.checkNewPricesForReview();
          this.remitosService.validateRemitos();
          this.navigationService.checkPermisos();
          // registramos al usuario en analytics
          this.registerAnalyticsUser(false);
        }
      }
    });

    moment.locale('es-ar');

    // this.firebaseService.onNewFirebaseMessage().subscribe( payload => {
    //   if (payload) {
    //     this.snackBar.openFromComponent(NotificationSnackbarComponent, {
    //       duration: 5000,
    //       data: payload.notification.body,
    //       extraClasses: ['agd-notification-snackbar']
    //     });
    //     this.actividadService.checkNewActivities();
    //     this.preciosService.checkNewPricesForReview();
    //   }
    // });

    this.avatarSubscription = this.avatarService.avatar$.subscribe(
      avatar => {
        this.avatarUrl = avatar;
      }
    );

    // TODO: CADA VEZ QUE SE AGREGUE UN NUEVO BUBBLE AGREGAR LA VARIABLE AL METODO showHideSideNavButtonBubble() PARA MOSTRARLO EN EL BOTÓN
    this.actividadService.checkComunicacionFlag$.subscribe(flag => {
      this.comunicadosBubble = flag;
      this.showHideSideNavButtonBubble();
    });

    // checkear el flag para validar precios
    this.preciosService.checkPrecioFlag$.subscribe(flag => {
      this.preciosBubble = flag;
      this.showHideSideNavButtonBubble();
    });

    this.preciosService.checkPrecioPizarraFlag$.subscribe(flag => {
      this.pizarraBubble = flag;
      this.showHideSideNavButtonBubble();
    });

    // as soon as token expires cancel the activity polling
    this.httpClient.tokenExpired().subscribe(expired => {
      if (expired) {
        this.actividadService.cancelCheckActivities();
        this.preciosService.cancelCheckActivities();
      }
    });

  }

  onProfileImageChange($event){
  }

  registerAnalyticsUser(cookie: boolean = true) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['userId'] = this.username;
    window['method'] = cookie ? 'token' : 'login';
    window['dataLayer'].push({
      'event' : 'login',
      'user_id': this.username,
      'method': window['method']
    });
  }

  updateProfileImage($event){
    this.avatarUrl = environment.ASSETS_URL + "avatar_colaborador.png";
  }

  loadNegocioOptions() {
    this.negociosService.loadOptions();
    this.monedaService.loadOptions();
    this.posicionService.loadOptions();
    this.productoService.loadOptions();
    this.cosechaService.loadOptions();
    this.entregaService.loadOptions();
    this.zonaService.loadOptions();
    this.permisosService.loadOptions();
    this.financieraService.loadOptions();
  }

  ngAfterViewInit() {
    this.toggleNav = () => {
      this.sideNav.toggle();
      this.navigationService.checkPermisos();
    };

    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }

        const contentContainer = document.querySelector('.mat-drawer-content');
        if (contentContainer){
          contentContainer.scrollTop = 0;
        }
    });
    if (this.username) {
      this.loadNegocioOptions();
      this.navigationService.checkPermisos();
      this.remitosService.validateRemitos();
      this.actividadService.checkNewActivities();
      this.preciosService.checkNewPricesForReview();
    }
  }

  logout() {
    this.sideNav.toggle();
    this.authService.logout();
    this.actividadService.cancelCheckActivities();
    this.preciosService.cancelCheckActivities();
  }

  showHideSideNavButtonBubble() {
    this.sideNavButtonBubble = this.preciosBubble || this.pizarraBubble || this.financieraBubble || this.comunicadosBubble;
  }

  showSectionButton(id) {
    return this.permisosService.permisoAutorizado(id);
  }

  registrarIconosSVG(): void {
    const basePath = `${environment.ASSETS_URL}svgIcons/`;
    // const basePath = '../assets/svgIcons/' // localstorage
    // por cada icono, creamos el objeto y con el DOM Sanitizer, marcamos el PATH del objeto como seguro
    this.matIconRegistry.addSvgIcon('agris', this.registrarSafePath(`${basePath}icon_Agris_24.svg`))
    this.matIconRegistry.addSvgIcon('girasol', this.registrarSafePath(`${basePath}icon_girasol_24.svg`))
    this.matIconRegistry.addSvgIcon('maiz', this.registrarSafePath(`${basePath}icon_maiz_24.svg`))
    this.matIconRegistry.addSvgIcon('soja', this.registrarSafePath(`${basePath}icon_soja_24.svg`))
    this.matIconRegistry.addSvgIcon('trigo', this.registrarSafePath(`${basePath}icon_trigo_24.svg`))
    this.matIconRegistry.addSvgIcon('help', this.registrarSafePath(`${basePath}help_outline_24.svg`))
    this.matIconRegistry.addSvgIcon('agris', this.registrarSafePath(`${basePath}icon_Agris_24.svg`))
    this.matIconRegistry.addSvgIcon('precios', this.registrarSafePath(`${basePath}precios_icon.svg`))
    this.matIconRegistry.addSvgIcon('precio-agd', this.registrarSafePath(`${basePath}precio_agd.svg`))
    this.matIconRegistry.addSvgIcon('creditos', this.registrarSafePath(`${basePath}icono_creditos.svg`))
    this.matIconRegistry.addSvgIcon('icono_prospecto', this.registrarSafePath(`${basePath}icono_prospecto.svg`))
  }

  registrarSafePath(path: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(path)
  }

  onScroll() {
    // esta logica esta implementada en CustomScrollbarComponent, en caso de dudas revisar dichos comentarios
    if (this.virtualScroll) {return;}
    this.scrollBar.setScrollPosition(this.navContainer.nativeElement.scrollTop);
  }

  onCustomScrollbarScrolled(amount: number) {
    // esta logica esta implementada en CustomScrollbarComponent, en caso de dudas revisar dichos comentarios
    this.virtualScroll = true;
    clearTimeout(this.scrollTimer);
    this.navContainer.nativeElement.scrollTop = amount;
    this.scrollTimer = window.setTimeout(() => {
      this.virtualScroll = false;
    }, 100);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/app.component.ts